module.exports = {"370271001":"红岛街道","370271002":"河套街道"}


//////////////////
// WEBPACK FOOTER
// ./src/town/370271.json
// module id = 1371
// module chunks = 0